import { defineMessages } from "react-intl";

import {
	Result,
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/neurology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	neurology: {
		id: "form.neurology",
		defaultMessage: "Neurológiai szakvizsgálat"
	},
	result: {
		id: "form.neurology.result",
		defaultMessage: "Eltérés"
	},
	[Result.ABNORMAL]: {
		id: "form.neurology.result.option.abnormal",
		defaultMessage: "Igen"
	},
	[Result.NORMAL]: {
		id: "form.neurology.result.option.normal",
		defaultMessage: "Nem"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "neurology",
	value: {
		title: messages.neurology,
		validator,
		fieldset
	}
};
